import {
  FinalConfirmModalInfoWrapper,
  FinalConfirmModalText,
  isMobileAtom,
  Styles,
  useRecoil,
} from '@orcar/common-d2c';

const RefundConfirm = () => {
  const { recoilValue: isMobile } = useRecoil(isMobileAtom);

  return (
    <>
      <FinalConfirmModalInfoWrapper isMobile={isMobile} hasList>
        <FinalConfirmModalText style={{ color: Styles.COLOR.RED }}>
          반려동물 동반 및 낚시용품 지참 불가
        </FinalConfirmModalText>
        <FinalConfirmModalText>외국인 대여 관련 사항</FinalConfirmModalText>
        <ul>
          <li>
            외국인 : 제네바 협약,비엔나 협약, SOFA 가입국에서 발행한
            국제운전면허증과 개인여권소지자
          </li>
          <li>
            국제 면허증을 소지한 외국인은 제2운전자로만 등록이 가능하며,
            제1운전자는 필히 자국 면허증을 소지해야 등록이 가능합니다.
          </li>
          <li>
            주한미군 - 개인여권과 오렌지카드(주한미군 운전면허증) / 여권이
            없거나, 영문 철자가 여권과 틀린 경우, 코팅 된 오렌지카드(주한미군
            운전면허증)는 렌트 불가함.
          </li>
          <li>
            국제면허증과 여권 - 국제운전면허증은 International Driving Permit 만
            가능 / 영문 철자가 틀린 경우, 이름이 풀네임으로 표기되지 않은
            경우(풀네임 확인 어려운 경우)는 렌트 불가함.
          </li>
        </ul>
        <FinalConfirmModalText>환불 사항</FinalConfirmModalText>
        <ul>
          <li>인수 불가에 따른 책임은 예약 당사자에게 있어요.</li>
          <li>인수 불가 시 취소에 따른 취소 수수료가 발생해요.</li>
          <li>취소 수수료는 당일 취소 수수료 구간이 적용돼요.</li>
        </ul>
      </FinalConfirmModalInfoWrapper>
    </>
  );
};

export default RefundConfirm;
